import { Suspense, useEffect, useState } from "react";
import Loading from "../../../../common/components/ui/loading/Loading";
import GenericTable from "../../../../common/components/ui/table/GenericTable";
import {
  getAverageConsumption,
  IAverageConsumption,
} from "../../../../common/services/stock.api";
import {
  TableFilters,
  TableFiltersState,
} from "../../../../common/components/ui/table/TableFilters";

function TablePurchaseSuggestion() {
  const [totalItems, setTotalItems] = useState(0);
  const [purchaseRequestor, setPurchaseRequestor] = useState<
    IAverageConsumption[]
  >([]);
  const [itemsPerPage, setItemsPerPage] = useState(30);
  const [isLoading, setIsLoading] = useState(false);
  const [filters, setFilters] = useState<TableFiltersState>({
    search: "",
    status: [],
  });

  const STATUS_LABELS = {};

  useEffect(() => {
    async function loadAverage(filters) {
      setIsLoading(true);

      const result = await getAverageConsumption();

      const enrichedData = result.data.map((item) => {
        const daysConsumption =
          typeof item.daysConsumption === "number" ? item.daysConsumption : 0;
        const quantity = typeof item.quantity === "number" ? item.quantity : 0;
        const projected = daysConsumption * itemsPerPage;
        return {
          ...item,
          projected,
          quantity,
        };
      });
      const filtered = enrichedData
        .filter((item) => item.daysConsumption > 0)
        .filter((item) => item.quantity < item.projected)
        .filter((item) =>
          filters.search
            ? item.name?.toLowerCase().includes(filters.search.toLowerCase()) ||
              item.code?.toLowerCase().includes(filters.search.toLowerCase())
            : true
        );
      setPurchaseRequestor(filtered);
      setTotalItems(filtered.length);
      setIsLoading(false);
    }
    loadAverage(filters);
  }, [filters, itemsPerPage]);
  const handleFilterChange = (newFilters: Partial<TableFiltersState>) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      ...newFilters,
    }));
  };
  return (
    <Suspense fallback={<Loading />}>
      <div
        className="pt-4 px-4 flex flex-col bg-white text-black dark:text-black flex-grow overflow-hidden h-full"
        style={{ maxHeight: "calc(100vh - 50px)", minHeight: "40px" }}
      >
        <TableFilters
          dashboardHeader="Sugestões de Compra"
          placeholder="Digite o nome da peça."
          statusOptions={STATUS_LABELS}
          hideStatusFilter
          onSearch={handleFilterChange}
          tableData={[]}
          entity="purchase-suggestion"
          reservationDays={itemsPerPage}
          setReservationDays={setItemsPerPage}
        />

        <GenericTable
          headers={{
            code: "Código",
            name: "Nome",
            quantity: "Quantidade de estoque",
            daysConsumption: "Consumo diário",
            projected: "Sugestão",
          }}
          data={purchaseRequestor}
          rowClassName={(item) => {
            const quantity =
              typeof item.quantity === "number" ? item.quantity : 0;
            const daysConsumption =
              typeof item.daysConsumption === "number"
                ? item.daysConsumption
                : 0;
            const projected = daysConsumption * itemsPerPage;
            return quantity > projected ? "text-black" : "text-redPrimary";
          }}
          renders={{
            quantity: (data: unknown) => <p>{Number(data)}</p>,
            daysConsumption: (data: unknown) => <p>{Number(data)}</p>,
            projected: (data: unknown) => <p>{Number(data)}</p>,
          }}
        />

        {!isLoading && (
          <div className="table-footer-text mt-4 mb-4">
            Mostrando: {totalItems} itens com sugestão
          </div>
        )}

        {isLoading && <Loading />}
      </div>
    </Suspense>
  );
}

export default TablePurchaseSuggestion;
